import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getSessionToken, isAdminSession } from "./shared/auth/session";

const ProtectedRoutes = () => {
  const token = getSessionToken();
  const isAdmin = isAdminSession();

  if (!token) return <Navigate to="/" />;

  return isAdmin ? <Outlet /> : <Navigate to="/home" />;
};

export default ProtectedRoutes;
